import React from 'react';
import {List, Segment} from "semantic-ui-react";
import Participant from "./Participant";

export default function ParticipantList(props) {
    return <div>
        {props.participants.length === 0 && <Segment textAlign='center' padded='very'>{props.emptyMessage}</Segment>}
        {props.participants.length > 0 && <Segment>
            <List>
                {props.participants.map((participant, index) =>
                    <List.Item key={index}>
                        <Participant gender={participant.gender}
                                     firstName={participant.firstName}
                                     lastName={participant.lastName}
                                     birthDate={participant.birthDate}
                                     onClick={(e) => props.onClickParticipant(e, participant)}/>
                    </List.Item>
                )}
            </List>
        </Segment>}
        {typeof props.errors !== "undefined" && <List style={{color: "#9f3a38", margin: ".28571429rem 0 0 0"}}>
            {props.errors.map((error, index) => <List.Item key={index}>{error}</List.Item>)}
        </List>}
    </div>
}


// WEBPACK FOOTER //
// ./src/components/application/ParticipantList.js